export const MASK_SHOW = 'MASK_SHOW'
export const INSERT_SCROLLTOP = 'INSERT_SCROLLTOP'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js